import { SET_PARTICIPANTS_LAYOUT } from './actionTypes';
/**
 * Sets the participants-display layout.
 *
 * @param {string} layout - The layout id (see PARTICIPANTS_LAYOUTS).
 * @returns {{ type: string, layout: string }}
 */
export function setParticipantsLayout(layout) {
    return {
        type: SET_PARTICIPANTS_LAYOUT,
        layout
    };
}
